import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transformWhile(_this__u8e3s4, transform) {
  return flow(transformWhile$slambda_0(_this__u8e3s4, transform));
}
var AbortFlowExceptionClass;
function AbortFlowException() {
  if (AbortFlowExceptionClass === VOID) {
    class $ extends CancellationException() {
      static t67(owner) {
        var $this = this.n('Flow was aborted, no more elements needed');
        captureStack($this, $this.s67_1);
        $this.r67_1 = owner;
        return $this;
      }
      u67(owner) {
        if (!(this.r67_1 === owner))
          throw this;
      }
    }
    initMetadataForClass($, 'AbortFlowException');
    AbortFlowExceptionClass = $;
  }
  return AbortFlowExceptionClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.v67_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.v67_1(value, $completion);
      }
      i5() {
        return this.v67_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var transformWhile$2$$inlined$collectWhile$1Class;
function transformWhile$2$$inlined$collectWhile$1() {
  if (transformWhile$2$$inlined$collectWhile$1Class === VOID) {
    class $ {
      constructor($transform, $this_flow) {
        this.w67_1 = $transform;
        this.x67_1 = $this_flow;
      }
      *q1g(value, $completion) {
        if (!(yield* this.w67_1(this.x67_1, value, $completion))) {
          throw AbortFlowException().t67(this);
        }
        return Unit_instance;
      }
      h1d(value, $completion) {
        return this.q1g(value, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [FlowCollector()], [1]);
    transformWhile$2$$inlined$collectWhile$1Class = $;
  }
  return transformWhile$2$$inlined$collectWhile$1Class;
}
var transformWhile$slambda$slambdaClass;
function transformWhile$slambda$slambda() {
  if (transformWhile$slambda$slambdaClass === VOID) {
    class $ {
      constructor($collector) {
        this.y67_1 = $collector;
      }
      *o1h(it, $completion) {
        yield* this.y67_1.q1g(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    transformWhile$slambda$slambdaClass = $;
  }
  return transformWhile$slambda$slambdaClass;
}
function transformWhile$slambda$slambda_0($collector) {
  var i = new (transformWhile$slambda$slambda())($collector);
  var l = (it, $completion) => i.o1h(it, $completion);
  l.$arity = 1;
  return l;
}
var transformWhile$slambdaClass;
function transformWhile$slambda() {
  if (transformWhile$slambdaClass === VOID) {
    class $ {
      constructor($this_transformWhile, $transform) {
        this.z67_1 = $this_transformWhile;
        this.a68_1 = $transform;
      }
      *b68($this$flow, $completion) {
        // Inline function 'com.apollographql.apollo.internal.collectWhile' call
        var this_0 = this.z67_1;
        var collector = new (transformWhile$2$$inlined$collectWhile$1())(this.a68_1, $this$flow);
        try {
          var tmp = transformWhile$slambda$slambda_0(collector);
          yield* this_0.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        } catch ($p) {
          if ($p instanceof AbortFlowException()) {
            var e = $p;
            e.u67(collector);
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.b68((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    transformWhile$slambdaClass = $;
  }
  return transformWhile$slambdaClass;
}
function transformWhile$slambda_0($this_transformWhile, $transform) {
  var i = new (transformWhile$slambda())($this_transformWhile, $transform);
  var l = ($this$flow, $completion) => i.b68($this$flow, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  transformWhile as transformWhile1eyv77fe96rjt,
};
//endregion

//# sourceMappingURL=flows.mjs.map
